import { useCallback, useState } from 'react';
import { adminCorporateUserService } from 'api/services/AdminCorporateUserService';

export function useCorporateUserApproval() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const withConfirm = useCallback(async (action: () => Promise<{ isSuccess: boolean; message?: string | null }>) => {
    if (!window.confirm('Emin misiniz?')) {
      return { isSuccess: false, message: 'İşlem iptal edildi.' };
    }
    setLoading(true);
    setError(null);
    try {
      const result = await action();
      if (!result.isSuccess) {
        setError(result.message ?? 'İşlem başarısız.');
      }
      return result;
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Bir hata oluştu.';
      setError(msg);
      return { isSuccess: false, message: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  const approve = useCallback(
    (id: string) => withConfirm(() => adminCorporateUserService.approve(id)),
    [withConfirm]
  );

  const reject = useCallback(
    (id: string) => withConfirm(() => adminCorporateUserService.reject(id)),
    [withConfirm]
  );

  const suspend = useCallback(
    (id: string) => withConfirm(() => adminCorporateUserService.suspend(id)),
    [withConfirm]
  );

  return { approve, reject, suspend, loading, error };
}
